module.exports = __webpack_public_path__ + "static/Bethells-fe3287037a99d9de31dd51d08df931e0.jpg";